export default "__VITE_ASSET__ceb74e14__"